module.exports = __webpack_public_path__ + "static/media/ic_triangle.c63b14d6.svg";